import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de poids moléculaire";
const DESCRIPTION =
  "Calculatrice de poids moléculaire. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "molecular weight calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/molecular-weight-calculator/";
const ELEMENTS = {
  H: 1.008, He: 4.0026, Li: 6.94, Be: 9.0122, B: 10.81, C: 12.011, N: 14.007,
  O: 15.999, F: 18.998, Ne: 20.18, Na: 22.99, Mg: 24.305, Al: 26.982,
  Si: 28.085, P: 30.974, S: 32.06, Cl: 35.45, Ar: 39.948, K: 39.098, Ca: 40.078,
};

function MolecularWeightCalculator() {
  const [selectedElement, setSelectedElement] = useState("");
  const [quantity, setQuantity] = useState();
  const [compound, setCompound] = useState([]);
  const [result, setResult] = useState(0);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");

  const handleAddElement = () => {
    if (selectedElement) {
      setCompound([...compound, { element: selectedElement, quantity }]);
      setSelectedElement("");
      setQuantity(1);
    }
  };

  const handleCalculate = () => {
    try {
      let totalWeight = 0;
      let calculationSteps = [];

      compound.forEach(({ element, quantity }) => {
        const elementWeight = ELEMENTS[element] * quantity;
        totalWeight += elementWeight;
        calculationSteps.push(
          `${quantity} × ${ELEMENTS[element]} (${element}) = ${elementWeight.toFixed(2)} g/mol`
        );
      });

      setResult(totalWeight);
      setSteps(calculationSteps);
      if (totalWeight === 0) {
        setError("Veuillez sélectionner des éléments pour effectuer le calcul");
        return;
      }
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule le poids moléculaire de tout composé 
                  chimique en utilisant la somme des poids atomiques des éléments 
                  qui le composent.
                </p>
                <p>
                  <strong>
                    Poids moléculaire = somme des poids atomiques des éléments 
                    qui composent le composé
                  </strong>
                </p>
                <ul>
                  <li>Sélectionnez l'élément chimique et le nombre d'atomes du composé.</li>
                  <li>Ajoutez les éléments qui composent le composé pour calculer le poids 
                  moléculaire total.</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <hr />
                  <div className="form-group">
                    <label className="form-label" htmlFor="element">
                      Choisir l'élément chimique
                    </label>
                    <select
                      id="element"
                      value={selectedElement}
                      onChange={(e) => setSelectedElement(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    >
                      <option value="">Choisir l'élément</option>
                      {Object.keys(ELEMENTS).map((el) => (
                        <option key={el} value={el}>
                          {el}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="quantity">
                      Nombre d'atomes
                    </label>
                    <input
                      id="quantity"
                      type="number"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginRight: "10px" }}
                    onClick={handleAddElement}
                  >
                    Ajouter l'élément
                  </button>
                  <br />
                  <ul>
                    {compound.map((item, index) => (
                      <li key={index}>
                        {item.quantity} × {item.element}
                      </li>
                    ))}
                  </ul>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginRight: "10px" }}
                    onClick={handleCalculate}
                  >
                    Calculer
                  </button>
                </div>
                <br />
                {error !== "" && (
                  <p className="p-3 mb-2 bg-warning text-black">
                    Erreur: {error}
                  </p>
                )}
                {result > 0 && (
                  <div className="p-3 mb-2 bg-success">
                    <h4 className="text-white">Résultat:</h4>
                    <p className="text-white">{result.toFixed(2)} g/mol</p>
                    <div className="p-3 mb-2 bg-info text-black" style={{ width: "100%" }}>
                      <h4>Étapes:</h4>
                      <ul>
                        {steps.map((step, index) => (
                          <li key={index}>{step}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
                <hr />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
    </div>
  );
}
export default MolecularWeightCalculator;
